import { LayoutDashboard, ClipboardCheck, PackageCheck, Store, Truck, BarChart3, Layers, TrendingUp, DollarSign, MessageSquare, Tag, PackageOpen, Map, Settings, Users } from 'lucide-react';
import { PortalLayout } from '@/components/portal/PortalLayout';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/applications', label: 'Applications', icon: ClipboardCheck },
  { to: '/admin/product-approvals', label: 'Product Approvals', icon: PackageCheck },
  { to: '/admin/farms', label: 'Farms', icon: Store },
  { to: '/admin/pricing', label: 'Pricing', icon: Tag },
  { to: '/admin/build-box-items', label: 'Build Box Items', icon: PackageOpen },
  { to: '/admin/routes', label: 'Delivery Routes', icon: Map },
  { to: '/admin/orders', label: 'Weekly Orders', icon: Truck },
  { to: '/admin/capacity', label: 'Supplier Capacity', icon: BarChart3 },
  { to: '/admin/backup', label: 'Backup Suppliers', icon: Layers },
  { to: '/admin/analytics', label: 'Recruitment', icon: TrendingUp },
  { to: '/admin/payments', label: 'Payments', icon: DollarSign },
  { to: '/admin/messages', label: 'Messages', icon: MessageSquare },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/settings', label: 'Settings', icon: Settings },
];

export default function AdminPortal() {
  return <PortalLayout title="FarmBox Admin" subtitle="Administrator" navItems={NAV} homeLink="/" />;
}
